import {css} from 'lit';
export const styles = css`[hidden],[inert],[inert]::slotted(*){display:none!important}`;
export default styles;
